import React, { useState } from "react";
import Grid from "@mui/material/Grid";

const About = ({ name, profileDetailsExtended }) => {
    // Show more/less logic for both sections
    const [showMoreAbout, setShowMoreAbout] = useState(false);
    const [showMoreWhy, setShowMoreWhy] = useState(false);
    const aboutText = profileDetailsExtended?.about || "";
    const whyText = profileDetailsExtended?.whyChoose || "";
    const aboutLong = aboutText.length > 1000;
    const whyLong = whyText.length > 1000;

    // Use same mobile check as in OurTechnology.js
    const isMobile = typeof window !== 'undefined' && window.innerWidth <= 600;

    // Helper to render text with line breaks
    const renderWithLineBreaks = (text) =>
        text.split('\n').map((line, idx, arr) =>
            idx === arr.length - 1 ? line : [line, <br key={idx} />]
        );

    return (
        <Grid container style={{ padding: isMobile ? '60px 30px' : '60px 60px', wordBreak: 'break-word', whiteSpace: 'normal' }}>
            <Grid size={12}>
                <h3 style={{ margin: 0, marginBottom: 20, fontSize: '26px' }}>Installer overview</h3>
            </Grid>
            <Grid size={12}>
                <p style={{ margin: 0, marginBottom: 30, wordBreak: 'break-word', whiteSpace: 'normal' }}>
                    {aboutLong && !showMoreAbout
                        ? renderWithLineBreaks(aboutText.slice(0, 1000) + '...')
                        : renderWithLineBreaks(aboutText)}
                    {aboutLong && (
                        <span
                            style={{ color: '#229626', cursor: 'pointer', marginLeft: 8, fontWeight: 600 }}
                            onClick={() => setShowMoreAbout((v) => !v)}
                        >
                            {showMoreAbout ? 'Show less' : 'Show more'}
                        </span>
                    )}
                </p>
            </Grid>
            <Grid size={12}>
                <h3 style={{ margin: 0, marginBottom: 20, fontSize: '26px' }}>Why choose us?</h3>
            </Grid>
            <Grid size={12}>
                <p style={{ margin: 0, wordBreak: 'break-word', whiteSpace: 'normal' }}>
                    {whyLong && !showMoreWhy
                        ? renderWithLineBreaks(whyText.slice(0, 1000) + '...')
                        : renderWithLineBreaks(whyText)}
                    {whyLong && (
                        <span
                            style={{ color: '#229626', cursor: 'pointer', marginLeft: 8, fontWeight: 600 }}
                            onClick={() => setShowMoreWhy((v) => !v)}
                        >
                            {showMoreWhy ? 'Show less' : 'Show more'}
                        </span>
                    )}
                </p>
            </Grid>
        </Grid>
    );
};

export default About;
